import styled from 'styled-components';

export const Wrapper = styled.div`
  button.close {
    margin: auto;
    display: block;
  }
`;
